import { restRequest } from "vrcore-dashboard/dist/utilities";

export const GET_REGISTERED_USERS = restRequest("MESSENGER.GET_REGISTERED_USERS");
export const SET_NEW_GROUP = restRequest("MESSENGER.SET_NEW_GROUP");
export const REMOVE_GROUP = restRequest("MESSENGER.REMOVE_GROUP");
export const EDIT_GROUP = restRequest("MESSENGER.EDIT_GROUP");
export const GET_GROUPS = restRequest("MESSENGER.GET_GROUPS");
export const ADD_GROUP_MESSAGE = restRequest("MESSENGER.ADD_GROUP_MESSAGE");
export const GET_DEPARTMENTS = restRequest("VRCORE.JOB_PACK_WIDGETS.JOB_PACK_ASSIGNEES_ARRAY_LIST.GET_DEPARTMENTS");
export const GET_AREAS = restRequest("VRCORE.JOB_PACK_WIDGETS.JOB_PACK_ASSIGNEES_ARRAY_LIST.GET_AREAS");

